import React from 'react';
import { Search, Phone, PhoneOutgoing, Video } from 'lucide-react';
import { Input } from '@/components/ui/input';

const roleLabel = (role) => {
  if (role === 'client') return 'Client';
  return role === 'admin' || role === 'org_admin' ? 'Administrateur' : 'Employe';
};

function ContactRow({ contact: c, isStaff, onCall, onPhoneCall, onVideoCall }) {
  return (
    <div data-testid={`softphone-contact-${c.id}`}
      className="flex items-center justify-between px-3 py-2.5 rounded-lg hover:bg-slate-800 transition-colors group">
      <div className="flex items-center gap-3 min-w-0">
        <div className="w-9 h-9 rounded-full bg-gradient-to-br from-slate-600 to-slate-700 flex items-center justify-center flex-shrink-0 text-white text-sm font-semibold">
          {(c.full_name || c.email || '?').charAt(0).toUpperCase()}
        </div>
        <div className="min-w-0">
          <p className="text-white text-sm font-medium truncate">{c.full_name || c.email}</p>
          <p className="text-slate-500 text-xs truncate">{roleLabel(c.role)}{c.phone ? ` · ${c.phone}` : ''}</p>
        </div>
      </div>
      <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
        <button data-testid={`softphone-call-webrtc-${c.id}`} onClick={() => onCall(c, 'webrtc')}
          className="p-2 rounded-lg bg-green-600/20 hover:bg-green-600/40 text-green-400 transition-colors" title="Appel navigateur (WebRTC)">
          <Phone className="w-4 h-4" />
        </button>
        {c.phone && isStaff && (
          <button data-testid={`softphone-call-phone-${c.id}`} onClick={() => onPhoneCall(c)}
            className="p-2 rounded-lg bg-blue-600/20 hover:bg-blue-600/40 text-blue-400 transition-colors" title={`Appel tel: ${c.phone}`}>
            <PhoneOutgoing className="w-4 h-4" />
          </button>
        )}
        <button data-testid={`softphone-call-video-${c.id}`} onClick={() => onVideoCall(c)}
          className="p-2 rounded-lg bg-indigo-600/20 hover:bg-indigo-600/40 text-indigo-400 transition-colors" title="Appel video">
          <Video className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}

export default function SoftPhoneContactsTab({ contacts, search, onSearchChange, isStaff, onCall, onPhoneCall, onVideoCall }) {
  return (
    <>
      <div className="p-3">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
          <Input data-testid="softphone-search-input" placeholder="Rechercher un contact..."
            value={search} onChange={e => onSearchChange(e.target.value)}
            className="pl-9 bg-slate-800 border-slate-700 text-white text-sm placeholder:text-slate-500 h-9" />
        </div>
      </div>
      <div className="overflow-y-auto flex-1 px-2 pb-2" style={{ maxHeight: '340px' }}>
        {contacts.length === 0 ? (
          <p className="text-slate-500 text-sm text-center py-6">Aucun contact</p>
        ) : contacts.map(c => (
          <ContactRow key={c.id} contact={c} isStaff={isStaff} onCall={onCall} onPhoneCall={onPhoneCall} onVideoCall={onVideoCall} />
        ))}
      </div>
    </>
  );
}
